import { render } from "./Forvaltare.vue?vue&type=template&id=2095bd73&scoped=true"
import script from "./Forvaltare.vue?vue&type=script&lang=js"
export * from "./Forvaltare.vue?vue&type=script&lang=js"

import "./Forvaltare.vue?vue&type=style&index=0&id=2095bd73&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2095bd73"]])

export default __exports__